/**
 * EVO — yuklanish skeleti.
 *
 * ╔══════════════════════════════════════════════════════════════════════════╗
 * ║ NIMA UCHUN SPINNER EMAS                                                  ║
 * ║                                                                          ║
 * ║ Aylanuvchi doira bitta narsani aytadi: «kut». Skelet esa NIMANI          ║
 * ║ kutayotganingni aytadi — uchta raqam keladimi yoki o'n qatorli jadval.   ║
 * ║                                                                          ║
 * ║ Ustiga, u sahifa SAKRASHINI oldini oladi: joy allaqachon kelayotgan      ║
 * ║ ma'lumot o'lchamida band bo'ladi, ya'ni raqam kelganda tugmalar joyidan  ║
 * ║ siljimaydi. Kassir kuniga yuz marta bosadigan tugma o'z o'rnida turishi  ║
 * ║ — tezlikdan ham muhimroq.                                                ║
 * ║                                                                          ║
 * ║ Spinner qolaveradi va u BOSHQA holat uchun: tugma bosilgandan keyingi    ║
 * ║ kutish (`Button` ichida), ya'ni «men bosdim, ishlayaptimi?» savoli.      ║
 * ╚══════════════════════════════════════════════════════════════════════════╝
 */
import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';

export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>): ReactNode {
  return (
    <div
      aria-hidden="true"
      className={cn('evo-skeleton rounded-md', className)}
      {...props}
    />
  );
}

/**
 * Jadval o'rnidagi skelet.
 *
 * `rows` — kutilayotgan qatorlar soni. Aniq son berish shart emas: taxminiy
 * balandlik ham sakrashni sezilarli kamaytiradi.
 */
export function SkeletonRows({
  rows = 5,
  className,
}: {
  readonly rows?: number;
  readonly className?: string;
}): ReactNode {
  return (
    <div className={cn('space-y-2', className)} role="status" aria-busy="true">
      {Array.from({ length: rows }, (_, i) => (
        /*
         * Kenglik ATAYLAB har xil: bir xil uzunlikdagi to'rtburchaklar
         * jadvalga emas, panjaraga o'xshaydi va «yuklanmoqda» degan
         * taassurot o'rniga «buzilgan» degan taassurot qoldiradi.
         */
        <Skeleton key={i} className={cn('h-8', i % 3 === 0 ? 'w-full' : i % 3 === 1 ? 'w-11/12' : 'w-4/5')} />
      ))}
    </div>
  );
}
